import { render, staticRenderFns } from "./AdminControlModal.vue?vue&type=template&id=b8fc5732&scoped=true&lang=html&"
import script from "./AdminControlModal.vue?vue&type=script&lang=js&"
export * from "./AdminControlModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminControlModal.vue?vue&type=style&index=0&id=b8fc5732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc5732",
  null
  
)

export default component.exports